/**
 * Helpers for building household invite URLs that the receiving `/join` page
 * can resolve via the `resolveInvite` Cloud Function.
 *
 * The host is the production web app origin (`app.zoeyorganizer.com`) so the
 * link works no matter which device scans the QR code.
 *
 * Mirrors iOS `HouseholdQRCodeView.swift` (`zoey_ios/.../HouseholdQRCodeView.swift`)
 * and Android `HouseholdQRCodeSheet.kt`, which build the same URL format.
 */

/** Production origin for the deployed web app. */
export const INVITE_BASE_URL = "https://app.zoeyorganizer.com";

/** Path segment of the invite landing page. */
export const INVITE_PATH = "/join";

/**
 * Build the canonical invite URL for a given token.
 *
 * The token is URL-encoded so any unexpected characters in the Firestore
 * document ID (used as the token) survive the round-trip.
 */
export function buildInviteUrl(token: string): string {
  const safe = encodeURIComponent(token);
  return `${INVITE_BASE_URL}${INVITE_PATH}?token=${safe}`;
}
